import React from 'react';
import { I18nProvider } from '@amzn/awsui-components-console/i18n';
import enMessages from '@amzn/awsui-components-console/i18n/messages/all.en.json';

import Chat from './chat';
import { UserInfo } from '../../services/api';
import { isInIframe } from '../../utils/iframe';

import '../../styles/base.scss';
import { CustomAppLayout } from "../../components/common-components";

interface ChatPageProps {
  user: UserInfo;
  contactId?: string;
}

export default function ChatPage({ user, contactId }: ChatPageProps) {
  const inIframe = isInIframe();

  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <CustomAppLayout
        maxContentWidth={1280}
        disableContentPaddings={inIframe}
        toolsHide
        navigationHide
        content={<Chat
          user={user}
          sessionId={contactId}
        />}
      />
    </I18nProvider>
  );
}